/**
 * The "Library:" line for one Media Station, shared by the station card and
 * the playlist confirm sheet so both read the same `stationSettings` entry
 * with the same wording (copy S-1 to S-5).
 *
 * @param {object|undefined} entry - `stationSettings[agentId]`
 * @param {string} settingsStatus - `stationSettingsStatus`
 * @returns {{tone: 'success'|'warning'|'error'|'muted', text: string, invalid: boolean}|null}
 *   null while the settings are still loading and there is nothing to show yet
 */
export const describeLibraryLine = (entry, settingsStatus) => {
  const station = entry?.station;

  if (station?.override?.enabled) {
    const name = station.override.libraryName || station.effective?.libraryName || 'Default';
    return { tone: 'warning', text: `Library: ${name} (set on the station)`, invalid: false };
  }
  if (station && station.validation?.valid === false) {
    return { tone: 'error', text: 'Library not found on station · using Default', invalid: true };
  }
  if (station?.effective) {
    return { tone: 'success', text: `Library: ${station.effective.libraryName || 'Default'}`, invalid: false };
  }
  if (settingsStatus === 'not_configured') {
    return { tone: 'muted', text: 'Library: set on the station', invalid: false };
  }
  if (!entry && (settingsStatus === 'idle' || settingsStatus === 'loading')) return null;
  return { tone: 'muted', text: `Library: ${entry?.libraryName || 'Default'} (not confirmed by station)`, invalid: false };
};
